import { JIRI_BAR_GAP, JIRI_BAR_HEIGHT } from '@/lib/hooks/useCustomTabBarHeight'
import useBrandColor from '@/lib/hooks/useBrandColor'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { useRouter } from 'expo-router'
import { SparklesIcon } from 'lucide-react-native'
import { useColorScheme } from 'nativewind'
import { Pressable, StyleSheet, Text } from 'react-native'

export default function JiriAccessoryBar() {
  const router = useRouter()
  const { colorScheme } = useColorScheme()
  const tintColor = useBrandColor()
  const [placeholderColor] = usePlatformColor('secondaryLabel')

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel="问问 Jiri"
      onPress={() => router.push('/jiri')}
      style={[
        styles.container,
        { backgroundColor: colorScheme === 'dark' ? 'rgba(118, 118, 128, 0.24)' : 'rgba(118, 118, 128, 0.12)' },
      ]}
    >
      <SparklesIcon size={18} color={tintColor as string} />
      <Text style={[styles.label, { color: placeholderColor }]} numberOfLines={1}>
        问问 Jiri…
      </Text>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    height: JIRI_BAR_HEIGHT,
    marginHorizontal: 16,
    marginBottom: JIRI_BAR_GAP,
    paddingHorizontal: 14,
    borderRadius: 20,
  },
  label: {
    flex: 1,
    fontSize: 15,
  },
})
